import React from 'react'
import NavigationBar from './NavigationBar/NavigationBar';
import { Outlet } from 'react-router-dom';
import Footer from './Footer/Footer';

const Layout = () => {
  return (
    <>
        <NavigationBar/>
        <Outlet/>
        <Footer/>
    </>
  )
}

export default Layout;